import "./styles/global.scss";
import Stomachshop from "./Stomachshop.svelte";
import {OpenAPI} from "./generated";
import {mount} from "svelte";
import {defineEvent} from "@otto-ec/global-resources/nexus";

/*                                      */
OpenAPI.BASE = window.location.origin;

const target = document.getElementById("js_squirrel_stomachshop") as HTMLElement;
target.innerHTML = "";
mount(Stomachshop, {
    target,
});

otto.stomachshop.assignNamespace({
    onSearchFocus: defineEvent(),
})

